import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { isMeetingRequest } from './isMeetingRequest';
import { MeetingMessageType } from 'mini-calendar-event-services/lib/schema/MeetingMessageType';

// This determines if for a new meeting item we must show the rsvp item
export const shouldMeetingItemDetailsShowRsvp = (meetingItem: MeetingMessageType) => {
    if (!meetingItem.Start || !meetingItem.End || !meetingItem.CalendarItemType) {
        return false;
    }

    // don't show RSVP for delegate scenarios
    if (!!meetingItem.IsDelegated && !!meetingItem.ReceivedRepresenting) {
        return false;
    }

    // Cases specific for meeting requests
    if (isMeetingRequest(meetingItem.ItemClass)) {
        const meetingRequest = meetingItem as MeetingRequestMessageType;

        // Don't want to show for no response required scenarios
        if (
            !meetingRequest.MeetingRequestType ||
            meetingRequest.MeetingRequestType === 'InformationalUpdate'
        ) {
            return false;
        }

        // Don't show RSVP if response type is unknown
        if (meetingItem.ResponseType === 'Unknown') {
            return false;
        }
    }

    return true;
};
